"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var scrollspy_1 = require("./scrollspy");
var scrollSpy = function scrollSpy(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var instance = new scrollspy_1.ScrollSpy(el, options);
  instance.onScroll();
  window.addEventListener('scroll', function () {
    return instance.onScroll();
  });
  return instance;
};
exports["default"] = scrollSpy;